import { Typography } from "@mui/material";
import { QuickFilterBox } from "./StyledComponents";

const QuickFilter = ({ highlighted, label, onClick }) => {

    return (
        <QuickFilterBox
            highlighted={highlighted}
            onClick={onClick}
            >
            <Typography
                variant="fw400s12c3D4B5A"
                sx={{
                    lineHeight: "16px",
                    color: highlighted ? "#6D72F6" : "#3D4B5A",
                    fontWeight: highlighted ? 500 : 400,
                }}
            >
                {label}
            </Typography>
        </QuickFilterBox>
    )

}
export default QuickFilter;
